import { Module } from '@nu-art/ts-common';
//TODO: re think about the typing in this class its far from perfect
class ModuleFE_Utils_Class extends Module {
    renderers = {};
    processors = {};
    // renderers
    // Method to register a renderer
    registerRenderer(key, renderer) {
        this.renderers[key] = renderer;
        return this;
    }
    // Method to remove a renderer
    removeRenderer(key) {
        delete this.renderers[key];
    }
    // Method to get a renderer by key and pass props
    getRenderer(key, props) {
        const renderer = this.renderers[key];
        if (!renderer) {
            throw new Error(`Renderer not found for key: ${key}`);
        }
        return renderer;
    }
    // assertion callbacks
    // Method to register a renderer
    registerProcessors(key, assertionCallback) {
        this.processors[key] = assertionCallback;
        return this;
    }
    // Method to remove a renderer
    removeProcessors(key) {
        delete this.processors[key];
    }
    // Method to get a renderer by key and pass props
    getProcessor(key) {
        const callback = this.processors[key];
        if (!callback) {
            throw new Error(`assertion callback not found for key: ${key}`);
        }
        return callback;
    }
}
export const ModuleFE_Utils = new ModuleFE_Utils_Class();
//# sourceMappingURL=ModuleFE_Utils.js.map